import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {RequeteDetail, RequeteService} from '../../entities/requete';

const MAX_TITLE_LENGTH = 150;

@Component({
    selector: 'jhi-modal-rename-dossier',
    templateUrl: './rename-dossier.component.html',
    styleUrls: ['./rename-dossier.component.scss']
})
export class RenameDossierComponent implements OnInit {

    @Input()
    dossier: RequeteDetail;

    maxTitleLength = MAX_TITLE_LENGTH;

    titleLengthExceeded = false;

    newTitle: string;

    constructor(public activeModal: NgbActiveModal,
                private requeteService: RequeteService) {
    }

    onSave() {
        this.newTitle = this.newTitle.substr(0, MAX_TITLE_LENGTH);
        this.requeteService.getById(this.dossier.id).subscribe(req => {
                this.requeteService.changerTitre(this.dossier.id, this.newTitle);
                this.dossier.titre = this.newTitle;
                if (req.titre !== this.dossier.titre) {
                    this.dossier.renamed = true;
                } else {
                    this.dossier.renamed = false;
                }
                return req;
            },
            error => {
                console.error('Ooops, could not retrieve Dossier with id: ' + this.dossier.id, error);
            },
            () => {
                this.activeModal.dismiss('Nom du dossier enregistré');
            });
    }

    ngOnInit(): void {
        this.newTitle = this.dossier.titre;

        // RGAA workaround
        const modalEl = document.querySelector('ngb-modal-window'); // Sélectionnez l'élément modal ng-bootstrap
        modalEl.setAttribute('aria-label', 'Renommer votre dossier'); // Ajoutez l'attribut aria-label
    }


    onTitleChange() {
        if (this.newTitle.length > MAX_TITLE_LENGTH) {
            this.titleLengthExceeded = true;
        } else {
            this.titleLengthExceeded = false;
        }
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/requete/rename-dossier/rename-dossier.component.ts